/** Invoice line item fields an org can hide on the portal. Hiding all of them hides the line items entirely. */
export var PortalLineItemField;
(function (PortalLineItemField) {
    PortalLineItemField["Description"] = "description";
    PortalLineItemField["Tracking"] = "tracking";
    PortalLineItemField["Quantity"] = "quantity";
    PortalLineItemField["UnitAmount"] = "unitAmount";
    PortalLineItemField["Total"] = "total";
})(PortalLineItemField || (PortalLineItemField = {}));
/** Unit for the max age of paid invoices shown on the customer portal */
export var PortalPaidMaxAgeUnit;
(function (PortalPaidMaxAgeUnit) {
    PortalPaidMaxAgeUnit["Months"] = "months";
    PortalPaidMaxAgeUnit["Years"] = "years";
})(PortalPaidMaxAgeUnit || (PortalPaidMaxAgeUnit = {}));
export var StatementColumns;
(function (StatementColumns) {
    StatementColumns["Date"] = "date";
    StatementColumns["Activity"] = "activity";
    StatementColumns["Reference"] = "reference";
    StatementColumns["DueDate"] = "duedate";
    StatementColumns["Amount"] = "amount";
    StatementColumns["Payments"] = "payments";
    StatementColumns["OverdueAge"] = "overdue_age";
    StatementColumns["Balance"] = "balance";
    StatementColumns["QBOPrivateNote"] = "QBOPrivateNote";
    StatementColumns["PromptPaymentDiscountAmount"] = "prompt_payment_discount_amount";
    StatementColumns["Tax"] = "tax";
    StatementColumns["NetAmount"] = "net_amount";
    StatementColumns["PaidDate"] = "paid_date";
})(StatementColumns || (StatementColumns = {}));
export var StatementLinkBehaviorTypes;
(function (StatementLinkBehaviorTypes) {
    StatementLinkBehaviorTypes["PORTAL"] = "portal";
    StatementLinkBehaviorTypes["DIRECT"] = "direct";
    StatementLinkBehaviorTypes["DISABLED"] = "disabled";
})(StatementLinkBehaviorTypes || (StatementLinkBehaviorTypes = {}));
export var CreditEffectOptions;
(function (CreditEffectOptions) {
    CreditEffectOptions["Ignore"] = "IGNORE";
    CreditEffectOptions["Deduct"] = "DEDUCT";
    CreditEffectOptions["DisplayOnly"] = "DISPLAY_ONLY";
})(CreditEffectOptions || (CreditEffectOptions = {}));
export var AlternativeInvoicePdfFallback;
(function (AlternativeInvoicePdfFallback) {
    AlternativeInvoicePdfFallback["UseXeroPdf"] = "USE_XERO_PDF";
    AlternativeInvoicePdfFallback["UseNoPdf"] = "USE_NO_PDF";
    AlternativeInvoicePdfFallback["ReportError"] = "REPORT_ERROR";
})(AlternativeInvoicePdfFallback || (AlternativeInvoicePdfFallback = {}));
export var StatementLogoPosition;
(function (StatementLogoPosition) {
    StatementLogoPosition["Right"] = "right";
    StatementLogoPosition["Top"] = "top";
})(StatementLogoPosition || (StatementLogoPosition = {}));
export var ContactAddressLocation;
(function (ContactAddressLocation) {
    ContactAddressLocation["Default"] = "default";
    ContactAddressLocation["Custom"] = "custom";
})(ContactAddressLocation || (ContactAddressLocation = {}));
//# sourceMappingURL=settings.js.map